import { Routes } from '@angular/router';
import { SelfCheckoutFormsFeatureModule } from '@app/verify/feature/forms';
import { provideSelfCheckoutDataAccess } from '@formunauts/self-checkout/data-access';
import { VerifyLocalizationModule } from './verify-l10n.module';
import { VerifyComponent } from './verify.component';

export const verifyShellRoutes: Routes = [
  {
    path: '',
    component: VerifyComponent,
    providers: [VerifyLocalizationModule, provideSelfCheckoutDataAccess()],
    loadChildren: () => SelfCheckoutFormsFeatureModule,
  },
];
